var map = {
	"./bat0.png": 209,
	"./bat1.png": 469,
	"./bat2.png": 470,
	"./bat3.png": 471,
	"./bat4.png": 472,
	"./bat5.png": 473,
	"./bat6.png": 474,
	"./bat7.png": 475,
	"./bat8.png": 476
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 468;


//////////////////
// WEBPACK FOOTER
// ./src/images/battery ^\.\/bat.*\.png$
// module id = 468
// module chunks = 0